/* ==========================================================================
   AKUMA 4x4 - DEALER & INSTALLER NETWORK
   --------------------------------------------------------------------------
   Powers two things:
     1. The locator on /pages/dealers  - search, filters, map, result cards
     2. The homepage Headquarters & Network map - HQ pin + every partner pin

   Reads window.AKUMA_DEALERS, emitted by snippets/akuma-dealers-data.liquid
   from the akuma_dealer metaobjects (or the bundled sample list while the
   real network is still being loaded).

   INTERACTION MODEL - read before changing anything
   --------------------------------------------------------------------------
   The map is a DISPLAY, never an input. Nothing on it is clickable, hoverable
   or focusable. A pin on a national map is ~5px on a phone, which is a third
   of the minimum sane tap target, so any tap interaction there is a promise
   the layout cannot keep.

   Instead the map REACTS: filter the list, search, or pick a dealer, and the
   map re-frames itself to whatever is showing. The list drives the map.

   No dependencies. No map provider, no API key, no third-party script -
   Australia is drawn as inline SVG and pins are plotted from lat/long.
   ========================================================================== */
(function () {
  'use strict';

  /* ----------------------------------------------------------------------
     1. GEOMETRY
     Simplified Australian coastline. Projection is linear on lng/lat, so
     any pin can be placed from its coordinates with the same maths.
     Base space: 1000 x 900 units. lng 112-154.5 - lat 9.5-44 (south).
  ---------------------------------------------------------------------- */
  var LNG0 = 112.0, LNG1 = 154.5, LAT0 = 9.5, LAT1 = 44.0, W = 1000, H = 900;

  function project(lng, lat) {
    return {
      x: (lng - LNG0) / (LNG1 - LNG0) * W,
      y: (Math.abs(lat) - LAT0) / (LAT1 - LAT0) * H
    };
  }

  var MAINLAND = 'M718.8,31.3 L736.5,78.3 L743.5,125.2 L783.5,142.2 L795.3,193.0 L807.1,229.6 L820.0,255.7 L851.8,275.2 L875.3,302.6 L896.5,335.2 L912.9,360.0 L924.7,375.7 L952.9,404.3 L967.1,427.8 L965.9,452.6 L975.3,470.9 L977.6,499.6 L967.1,542.6 L962.4,572.6 L954.1,598.7 L936.5,610.4 L924.7,635.2 L915.3,662.6 L903.5,683.5 L898.8,707.0 L892.9,731.7 L861.2,738.3 L830.6,753.9 L809.4,765.7 L790.6,755.2 L778.8,753.9 L769.4,746.1 L752.9,756.5 L734.1,764.3 L705.9,759.1 L682.4,752.6 L658.8,733.0 L649.4,707.0 L642.4,688.7 L625.9,682.2 L622.4,660.0 L616.5,640.4 L609.4,662.6 L601.2,671.7 L592.9,662.6 L608.2,620.9 L606.6,601.3 L595.3,613.0 L583.5,639.1 L564.7,662.6 L548.2,654.8 L538.8,620.9 L522.4,607.8 L494.1,592.2 L458.8,573.9 L423.5,576.5 L388.2,584.3 L341.2,594.8 L305.9,607.8 L272.9,636.5 L240.0,639.1 L200.0,636.5 L164.7,649.6 L138.8,667.8 L108.2,667.8 L88.2,648.3 L71.8,628.7 L80.0,602.6 L88.2,588.3 L72.9,547.8 L61.2,503.5 L51.8,474.8 L32.9,433.0 L40.0,399.1 L38.8,367.8 L50.6,341.7 L75.3,307.8 L112.9,292.2 L155.3,281.7 L192.9,271.3 L225.9,242.6 L241.2,224.3 L261.2,200.9 L272.9,180.0 L296.5,180.0 L320.0,177.4 L343.5,151.3 L371.8,148.7 L390.6,148.7 L407.1,146.1 L414.1,130.4 L428.2,96.5 L442.4,74.3 L468.2,73.0 L484.7,67.8 L503.5,57.4 L524.7,65.2 L548.2,70.4 L569.4,67.8 L581.2,73.0 L585.9,107.0 L564.7,125.2 L550.6,143.5 L571.8,159.1 L588.2,172.2 L616.5,185.2 L647.1,203.5 L680.0,213.9 L696.5,174.8 L691.8,130.4 L696.5,96.5 L703.5,78.3 L708.2,47.0 Z';

  var TAS = 'M769.4,813.9 L800.0,827.0 L854.1,819.1 L854.1,860.9 L844.7,887.0 L821.2,889.6 L788.2,871.3 L767.1,827.0 Z';

  var BORDERS = [
    'M400.0,146.1 L400.0,577.8',
    'M400.0,430.4 L611.8,430.4',
    'M611.8,193.0 L611.8,430.4',
    'M611.8,430.4 L682.4,430.4',
    'M682.4,430.4 L682.4,752.6',
    'M682.4,508.7 L868.2,506.1 L924.7,511.3 L952.9,490.4 L976.5,487.8',
    'M682.4,639.1 L727.1,644.3 L743.5,665.2 L769.4,680.9 L797.6,688.7 L821.2,691.3 L835.3,693.9 L851.8,704.3 L858.8,712.2 L870.6,720.0 L891.8,730.4'
  ];

  var ACT = [872.9, 673.0];

  var STATE_LABELS = [
    ['WA', 121.0, -25.5], ['NT', 133.3, -19.5], ['SA', 135.0, -29.8],
    ['QLD', 144.3, -22.5], ['NSW', 146.6, -32.4], ['VIC', 143.9, -36.9],
    ['TAS', 141.8, -42.2]
  ];

  var STATE_ORDER = ['QLD', 'NSW', 'ACT', 'VIC', 'TAS', 'SA', 'WA', 'NT'];
  var LABEL = { dealer: 'Dealer', installer: 'Installer', both: 'Dealer + Installer' };
  var CLS   = { dealer: 'is-dealer', installer: 'is-installer', both: 'is-both' };

  var NS = 'http://www.w3.org/2000/svg';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* Dealer websites are typed by hand into a plain text metaobject field, so
     half of them arrive as "akuma4x4.com.au" or "www.example.com.au" with no
     scheme. A bare domain in an href is read as a RELATIVE PATH, so the link
     quietly points at akuma4x4.com.au/pages/www.example.com.au and 404s - it
     looks like the external link is broken when it is really just missing its
     https://. Add one. Anything script-ish is dropped rather than rendered. */
  function safeUrl(u) {
    u = String(u == null ? '' : u).trim();
    if (!u) return '';
    if (/^(javascript|data|vbscript):/i.test(u)) return '';
    if (/^(https?:\/\/|\/\/|\/|#|mailto:|tel:)/i.test(u)) return u;
    return 'https://' + u;
  }

  /* ----------------------------------------------------------------------
     2. MAP RENDERING
     The whole SVG is role="img" and pointer-events:none in CSS. It is a
     picture that reacts to the controls, not a control itself.
  ---------------------------------------------------------------------- */
  function buildMap(host, opts) {
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', opts.viewBox);
    svg.setAttribute('role', 'img');
    svg.setAttribute('aria-label', opts.label ||
      'Map of Australia showing Akuma authorised dealer and installer locations');

    var html = '';
    html += '<path class="land" d="' + MAINLAND + '"/>';
    html += '<path class="land" d="' + TAS + '"/>';
    BORDERS.forEach(function (d) { html += '<path class="border" d="' + d + '"/>'; });
    html += '<circle class="border" cx="' + ACT[0] + '" cy="' + ACT[1] +
            '" r="9" style="stroke-dasharray:none;stroke:rgba(255,255,255,.22)"/>';

    if (opts.stateLabels !== false) {
      STATE_LABELS.forEach(function (s) {
        var p = project(s[1], s[2]);
        html += '<text class="state-label" x="' + p.x.toFixed(1) + '" y="' + p.y.toFixed(1) +
                '">' + s[0] + '</text>';
      });
    }

    html += '<g class="pin-layer"></g>';

    // HQ marker LAST so it draws on top of any metro pin sitting under it -
    // it has to be the most prominent thing on the map.
    if (opts.hq) {
      var h = project(opts.hq.lng, opts.hq.lat);
      var hr = opts.hq.r || 15;              // core radius
      var hx = (h.x + hr + 16).toFixed(1);   // label gutter clears the core
      html += '<g class="hq-pin">' +
                '<circle class="hq-ring" cx="' + h.x.toFixed(1) + '" cy="' + h.y.toFixed(1) + '" r="' + (hr * 2) + '"/>' +
                '<circle class="hq-ring hq-ring-2" cx="' + h.x.toFixed(1) + '" cy="' + h.y.toFixed(1) + '" r="' + (hr * 2) + '"/>' +
                '<circle class="hq-core" cx="' + h.x.toFixed(1) + '" cy="' + h.y.toFixed(1) + '" r="' + hr + '"/>' +
                '<circle class="hq-pip"  cx="' + h.x.toFixed(1) + '" cy="' + h.y.toFixed(1) + '" r="' + (hr * 0.34).toFixed(1) + '"/>' +
                '<text class="hq-label" x="' + hx + '" y="' + (h.y - 2).toFixed(1) + '">' +
                  esc(opts.hq.label) + '</text>' +
                '<text class="hq-sublabel" x="' + hx + '" y="' + (h.y + 17).toFixed(1) + '">' +
                  esc(opts.hq.sublabel) + '</text>' +
              '</g>';
    }

    svg.innerHTML = html;
    host.appendChild(svg);
    return { svg: svg, layer: svg.querySelector('.pin-layer') };
  }

  // grouped = true renders every partner identically (homepage). The
  // dealer / installer split is carried by the badges on the locator page.
  //
  // On the locator the two pin styles answer one question: does this place
  // fit the gear as well as sell it? Solid red = yes. Hollow = sells only.
  // Filled beats outlined, so the weight sits on the partners who do more -
  // and since everyone in the network sells, the hollow pin is the exception.
  // (A fitting-only partner, if one is ever added, gets a solid pin - it does
  // fit - and its card badge says Installer.)
  //
  // Pins carry no tabindex, role or handlers - they are decoration.
  function buildPins(layer, data, r, grouped) {
    var halo = r * 2.8, pins = [];
    data.forEach(function (d, i) {
      var p = project(d.lng, d.lat);
      var g = document.createElementNS(NS, 'g');
      g.setAttribute('class', 'pin' + (!grouped && d.type === 'dealer' ? ' is-salesonly' : ''));
      g.setAttribute('data-i', i);
      g.innerHTML =
        '<circle class="pin-halo" cx="' + p.x.toFixed(1) + '" cy="' + p.y.toFixed(1) + '" r="' + halo + '"/>' +
        '<circle class="pin-dot"  cx="' + p.x.toFixed(1) + '" cy="' + p.y.toFixed(1) + '" r="' + r + '"/>';
      g.__pt = p;
      layer.appendChild(g);
      pins.push(g);
    });
    return pins;
  }

  /* ----------------------------------------------------------------------
     3. RE-FRAMING
     Animates the viewBox to fit whatever pins are currently showing, so
     filtering to WA actually zooms the map to WA. viewBox is not a CSS
     property, so it is interpolated by hand on rAF.
  ---------------------------------------------------------------------- */
  function makeFramer(svg, baseViewBox) {
    var base = baseViewBox.split(/[ ,]+/).map(Number);   // [x, y, w, h]
    var raf = null, last = null;
    var MIN_SPAN = 420;          // stops a single pin zooming to absurdity
    var PAD = 0.28;              // breathing room around the fitted box

    var reduce = window.matchMedia &&
                 window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function apply(v) { svg.setAttribute('viewBox', v.map(function (n) { return n.toFixed(1); }).join(' ')); }

    /* The viewBox has to match the SHAPE OF THE BOX ON SCREEN, not the shape of
       the source artwork. On mobile the map is a short wide banner; fitting a
       tall viewBox into it would letterbox the country into a thin strip in the
       middle. So every box we compute is grown out to the rendered aspect. */
    function viewAspect() {
      var r = svg.getBoundingClientRect();
      return (r.width > 4 && r.height > 4) ? r.width / r.height : base[2] / base[3];
    }
    function toAspect(box, aspect) {
      var w = box[2], h = box[3];
      var cx = box[0] + w / 2, cy = box[1] + h / 2;
      if (w / h > aspect) h = w / aspect; else w = h * aspect;
      return [cx - w / 2, cy - h / 2, w, h];
    }

    var cur = toAspect(base, viewAspect());
    apply(cur);

    function target(points) {
      var aspect = viewAspect();
      var full = toAspect(base, aspect);          // whole country, current box shape
      if (!points || points.length === 0) return full;

      var xs = points.map(function (p) { return p.x; });
      var ys = points.map(function (p) { return p.y; });
      var minX = Math.min.apply(null, xs), maxX = Math.max.apply(null, xs);
      var minY = Math.min.apply(null, ys), maxY = Math.max.apply(null, ys);

      var cx = (minX + maxX) / 2, cy = (minY + maxY) / 2;
      var w = Math.max(maxX - minX, MIN_SPAN) * (1 + PAD);
      var h = Math.max(maxY - minY, MIN_SPAN) * (1 + PAD);

      var box = toAspect([cx - w / 2, cy - h / 2, w, h], aspect);
      w = box[2]; h = box[3];

      // never zoom out past the full map, never pan off it
      if (w >= full[2] || h >= full[3]) return full;
      var x = Math.min(Math.max(cx - w / 2, full[0]), full[0] + full[2] - w);
      var y = Math.min(Math.max(cy - h / 2, full[1]), full[1] + full[3] - h);
      return [x, y, w, h];
    }

    function run(points, instant) {
      last = points;
      var to = target(points);
      if (raf) cancelAnimationFrame(raf);
      if (reduce || instant) { cur = to; apply(cur); return; }

      var from = cur.slice(), t0 = null, DUR = 480;
      function step(ts) {
        if (t0 === null) t0 = ts;
        var k = Math.min(1, (ts - t0) / DUR);
        var e = k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;  // easeInOutCubic
        cur = from.map(function (v, i) { return v + (to[i] - v) * e; });
        apply(cur);
        if (k < 1) raf = requestAnimationFrame(step); else raf = null;
      }
      raf = requestAnimationFrame(step);
    }

    // Rotating the phone changes the box shape, so the frame has to be redone.
    var rt = null;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { run(last, true); }, 160);
    });

    return function reframe(points) { run(points); };
  }

  /* ----------------------------------------------------------------------
     4. HOMEPAGE MAP - static picture, no interaction of any kind
  ---------------------------------------------------------------------- */
  function initHomeMap(root, data) {
    var box = root.querySelector('[data-map-box]');
    if (!box || box.querySelector('svg')) return;   // theme editor re-renders

    var built = buildMap(box, {
      viewBox: root.getAttribute('data-viewbox') || '-20 -15 1230 930',
      label: 'Map of Australia showing the Akuma Brisbane headquarters and ' +
             data.length + ' authorised dealer and installer locations',
      hq: {
        lat: parseFloat(root.getAttribute('data-hq-lat')) || -27.47,
        lng: parseFloat(root.getAttribute('data-hq-lng')) || 153.03,
        label: root.getAttribute('data-hq-label') || 'Brisbane',
        sublabel: root.getAttribute('data-hq-sublabel') || 'Headquarters',
        r: parseFloat(root.getAttribute('data-hq-size')) || 15
      }
    });

    buildPins(built.layer, data, parseFloat(root.getAttribute('data-pin-size')) || 10, true);
  }

  /* ----------------------------------------------------------------------
     5. LOCATOR PAGE
  ---------------------------------------------------------------------- */
  function initLocator(root, data) {
    var box     = root.querySelector('[data-map-box]');
    var results = root.querySelector('[data-results]');
    var countEl = root.querySelector('[data-count]');
    var input   = root.querySelector('[data-search]');
    var clear   = root.querySelector('[data-clear]');
    if (!results || results.getAttribute('data-ready')) return;
    results.setAttribute('data-ready', '1');   // theme editor re-renders

    var baseVB = root.getAttribute('data-viewbox') || '0 0 1000 900';
    var built = box ? buildMap(box, { viewBox: baseVB }) : null;
    var pins  = built ? buildPins(built.layer, data, 6.5, false) : [];
    var reframe = built ? makeFramer(built.svg, baseVB) : function () {};

    var q = '', state = 'ALL', type = 'all', picked = -1;

    var m = /[?&]state=([A-Za-z]{2,3})/.exec(window.location.search);
    if (m && STATE_ORDER.indexOf(m[1].toUpperCase()) > -1) state = m[1].toUpperCase();

    function typeOk(d) {
      if (type === 'dealer'    && d.type === 'installer') return false;
      if (type === 'installer' && d.type === 'dealer')    return false;
      return true;
    }
    function matches(d) {
      if (state !== 'ALL' && d.state !== state) return false;
      if (!typeOk(d)) return false;
      if (!q) return true;
      return (d.name + ' ' + d.suburb + ' ' + d.state + ' ' + d.postcode).toLowerCase().indexOf(q) > -1;
    }

    function card(d, i) {
      var tel = String(d.phone || '').replace(/[^0-9+]/g, '');
      var site = safeUrl(d.website);
      return '<article class="dealer-card" data-i="' + i + '" tabindex="0">' +
        '<div class="dealer-card-top">' +
          '<div>' +
            '<p class="loc">' + esc(d.suburb) + ' · ' + esc(d.state) +
              (d.postcode ? ' ' + esc(d.postcode) : '') + '</p>' +
            '<h3>' + esc(d.name) + '</h3>' +
          '</div>' +
          '<span class="dealer-badge ' + CLS[d.type] + '">' + LABEL[d.type] + '</span>' +
        '</div>' +
        (d.blurb ? '<p class="note">' + esc(d.blurb) + '</p>' : '') +
        '<div class="dealer-card-foot">' +
          (d.phone ? '<a href="tel:' + tel + '">' + esc(d.phone) + '</a>' : '') +
          (site ? '<a class="site" href="' + esc(site) + '" target="_blank" rel="noopener noreferrer">Visit website</a>' : '') +
        '</div>' +
      '</article>';
    }

    var emptyTpl = root.querySelector('[data-empty-template]');
    var emptyHTML = emptyTpl ? emptyTpl.innerHTML :
      '<div class="dealers-empty"><h3>Nothing in that patch yet</h3>' +
      '<p>Order direct and we will freight it to you.</p></div>';

    function render() {
      var shown = [];
      data.forEach(function (d, i) { if (matches(d)) shown.push(i); });

      // a pick that has been filtered out is no longer a pick
      if (picked > -1 && shown.indexOf(picked) === -1) picked = -1;

      if (countEl) {
        countEl.innerHTML = '<strong>' + shown.length + '</strong><span>' +
          (shown.length === 1 ? 'location' : 'locations') +
          (state !== 'ALL' ? ' in ' + state : ' nationally') + '</span>';
      }

      results.innerHTML = shown.length
        ? shown.map(function (i) { return card(data[i], i); }).join('')
        : emptyHTML;

      pins.forEach(function (g, i) {
        g.classList.toggle('is-dimmed', shown.indexOf(i) === -1);
        g.classList.toggle('is-active', i === picked);
      });
      if (picked > -1) {
        var c = results.querySelector('.dealer-card[data-i="' + picked + '"]');
        if (c) c.classList.add('is-active');
      }

      /* The map follows the list.
         Nothing filtered and nothing picked = the whole country. The default
         view is a national coverage map, not a box drawn around wherever the
         dealers happen to be today - that would crop Australia for no reason
         and change shape every time a dealer is added.
         Pick one = frame that pin. Filter = frame what is left. */
      var untouched = (state === 'ALL' && type === 'all' && !q && picked === -1);
      reframe(untouched ? null
        : picked > -1
          ? [pins[picked].__pt]
          : shown.map(function (i) { return pins[i] && pins[i].__pt; }).filter(Boolean));

      Array.prototype.forEach.call(root.querySelectorAll('[data-chip]'), function (btn) {
        var s = btn.getAttribute('data-chip');
        var n = data.filter(function (d) {
          return (s === 'ALL' || d.state === s) && typeOk(d);
        }).length;
        var nEl = btn.querySelector('.n');
        if (nEl) nEl.textContent = n;
        btn.setAttribute('aria-pressed', String(s === state));
        btn.hidden = (s !== 'ALL' && n === 0);
      });
    }

    // Picking a card frames its pin. Picking it again releases it.
    function pick(i) { picked = (picked === i) ? -1 : i; render(); }

    results.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;              // let phone / website links through
      var c = e.target.closest('.dealer-card');
      if (c) pick(+c.getAttribute('data-i'));
    });
    results.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var c = e.target.closest && e.target.closest('.dealer-card');
      if (!c || e.target.closest('a')) return;
      e.preventDefault();
      pick(+c.getAttribute('data-i'));
    });

    if (input) input.addEventListener('input', function () {
      q = input.value.trim().toLowerCase(); picked = -1; render();
    });
    if (clear) clear.addEventListener('click', function () {
      q = ''; state = 'ALL'; type = 'all'; picked = -1;
      if (input) input.value = '';
      Array.prototype.forEach.call(root.querySelectorAll('[data-type]'), function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-type') === 'all'));
      });
      render();
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-chip]'), function (btn) {
      btn.addEventListener('click', function () {
        var s = btn.getAttribute('data-chip');
        state = (state === s) ? 'ALL' : s;
        picked = -1;
        render();
      });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-type]'), function (btn) {
      btn.addEventListener('click', function () {
        type = btn.getAttribute('data-type');
        picked = -1;
        Array.prototype.forEach.call(root.querySelectorAll('[data-type]'), function (b) {
          b.setAttribute('aria-pressed', String(b === btn));
        });
        render();
      });
    });

    render();
  }

  /* ----------------------------------------------------------------------
     6. BOOT
  ---------------------------------------------------------------------- */
  function boot() {
    var data = (window.AKUMA_DEALERS || []).filter(function (d) {
      return d && d.lat && d.lng && d.name;
    });

    Array.prototype.forEach.call(document.querySelectorAll('[data-akuma-network]'), function (root) {
      var total = root.querySelector('[data-total]');
      var states = root.querySelector('[data-statecount]');
      if (total) total.textContent = data.length;
      if (states) {
        var seen = {};
        data.forEach(function (d) { seen[d.state] = 1; });
        states.textContent = Object.keys(seen).length;
      }
      initHomeMap(root, data);
    });

    Array.prototype.forEach.call(document.querySelectorAll('[data-akuma-locator]'), function (root) {
      initLocator(root, data);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', boot);
})();
